import {Button} from "@mui/material";
import {grey} from "@mui/material/colors";

export const CancelButton = ({sx = {}, children, ...props}) => (
  <Button variant={"contained"} elevation={0}
          sx={{px: 3, bgcolor: grey[200], color: "secondary.main", textTransform: 'capitalize', "&:hover": {bgcolor: grey[300]}, ...sx}}
          {...props}
  >
    {children || "Cancel"}
  </Button>
)